import script from "./GlobalKyc.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalKyc.vue?vue&type=script&setup=true&lang=js"

import "./GlobalKyc.vue?vue&type=style&index=0&id=3eec1293&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eec1293"]])

export default __exports__